import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary';
import AppLayout from '../AppLayout';
import AppRouter from '../AppRouter';

function App({ pageData = {}, storeConf = {}, sharedConfig = {} }: any) {
  return (
    <ErrorBoundary>
      <Routes>
        <Route
          path="*"
          element={
            <AppLayout pageData={pageData} storeConf={storeConf} sharedConfig={sharedConfig} />
          }
        >
          <Route
            path="*"
            element={
              <AppRouter pageData={pageData} storeConf={storeConf} sharedConfig={sharedConfig} />
            }
          />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
